/*
 * Copyright (c) Schrocken Inc.
 * Author: Ravi Teja
 * File Description: Main index file for all reducer files
 */

import { combineReducers } from 'redux';

import authReducer from './authReducer';
import userReducer from './userReducer';
import ecosystemReducer from './ecosystemReducer';
import ErrorReducer from './errorReducer';

//user invitation reducer
import userInviteReducer from './inviteUsers';

import pcmpReducer from '../../components/pcmp/containers/reducers';

export default combineReducers({
  auth: authReducer,
  user: userReducer,
  ecosystems: ecosystemReducer,
  errors: ErrorReducer,
  usersInvitation: userInviteReducer,
  pcmp: pcmpReducer,
});
